"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styles_1 = __importDefault(require("./styles"));
const react_native_1 = require("react-native");
const ModalSuccess_1 = __importDefault(require("../../../components/modal/ModalSuccess"));
const ModalMenu_1 = __importDefault(require("../../../components/modal/ModalMenu"));
const scale_1 = require("../../../utils/scale");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const ItemHashtag_1 = __importDefault(require("../components/ItemHashtag"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const Home_1 = __importDefault(require("../../../networking/apis/Home"));
const skeletons_1 = require("../../../components/skeletons");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const components_1 = require("../../../components");
const ListHashtagScreen = () => {
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const [visibleMenu, setVisibleMenu] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [visibleToast, setVisibleToast] = (0, react_1.useState)(false);
    const [contentToast, setContentToast] = (0, react_1.useState)('');
    const [listData, setListData] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);
    (0, react_1.useEffect)(() => {
        setContentToast('');
        callApi();
    }, []);
    const callApi = async () => {
        const res = await Home_1.default.hashtagArticles(2);
        setListData(res?.data);
    };
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        loading ? (react_1.default.createElement(skeletons_1.ArticleSkeleton, null)) : (react_1.default.createElement(react_native_1.ScrollView, { contentContainerStyle: { paddingBottom: inset.bottom + (0, scale_1.scale)(130) }, showsVerticalScrollIndicator: false },
            react_1.default.createElement(CustomText_1.default, { style: {
                    lineHeight: (0, scale_1.moderateScale)(27),
                    color: '#292A33',
                    paddingVertical: (0, scale_1.scale)(12),
                    paddingLeft: (0, scale_1.scale)(16),
                }, weight: "600", size: (0, scale_1.moderateScale)(18) }, "\u4EBA\u6C17\u306E\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0"),
            react_1.default.createElement(react_native_1.View, { style: { paddingHorizontal: (0, scale_1.scale)(16) } }, listData?.hash_tags?.map((item, index) => {
                return (react_1.default.createElement(ItemHashtag_1.default, { data: item, key: index, onOpenHashtag: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                            screen: Routes_1.default.HASHTAG_DETAIL,
                            params: {
                                hashtag: item?.hash_tag_name,
                                typeScreen: 0,
                                typeHashTag: 2,
                            },
                        });
                    } }));
            })),
            react_1.default.createElement(components_1.LinkButton, { title: '\u5168\u3066\u306E\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0\u3092\u898B\u308B', style: { marginVertical: (0, scale_1.scale)(24), marginLeft: (0, scale_1.scale)(16), }, onPress: () => {
                    (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                        screen: Routes_1.default.HASHTAG,
                        params: {
                            typeHashTag: 2,
                        },
                    });
                } }),
            react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                    fontSize: (0, scale_1.moderateScale)(18),
                    lineHeight: (0, scale_1.moderateScale)(27),
                    marginLeft: (0, scale_1.scale)(16),
                    marginBottom: (0, scale_1.scale)(12),
                } }, "\u6700\u8FD1\u898B\u305F\u81EA\u5206\u53F2\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0"),
            react_1.default.createElement(react_native_1.View, { style: {
                    flexDirection: 'row',
                    maxWidth: (0, scale_1.scale)(343),
                    flexWrap: 'wrap',
                    marginLeft: (0, scale_1.scale)(16),
                } }, listData?.recently_viewed_hash_tags?.map((hashtag, index) => {
                return (react_1.default.createElement(CustomText_1.default, { key: index, style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#007AFF',
                        marginRight: (0, scale_1.scale)(10),
                    }, onPress: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                            screen: Routes_1.default.HASHTAG_DETAIL,
                            params: {
                                hashtag: hashtag.name,
                                typeScreen: 0,
                                typeHashTag: 1,
                            },
                        });
                    } }, `#${hashtag.name}`));
            })))),
        react_1.default.createElement(ModalMenu_1.default, { visible: visibleMenu, onClose: () => setVisibleMenu(false) }),
        react_1.default.createElement(ModalSuccess_1.default, { visible: visibleToast, onClose: () => setVisibleToast(false), content: contentToast })));
};
exports.default = ListHashtagScreen;
